/** Local copy of master data needed to create documents offline. */
const asList = (d) => (Array.isArray(d) ? d : d?.items || []);

export async function refreshCache(api, store) {
  const [parties, products, warehouses] = await Promise.all([
    api.get("/parties/", { params: { role: "customer", page_size: 200 } }),
    api.get("/inventory/products", { params: { is_active: true, limit: 500 } }),
    api.get("/inventory/warehouses"),
  ]);
  const snap = {
    parties: asList(parties.data),
    products: asList(products.data),
    warehouses: asList(warehouses.data),
    refreshedAt: new Date().toISOString(),
  };
  await store.put("cache", "masters", snap);
  return snap;
}

export async function readCache(store) {
  return (await store.get("cache", "masters")) || { parties: [], products: [], warehouses: [], refreshedAt: null };
}
